<template>
    <div class="hospital-stats-container">
        <div class="search-filter-row">
            <input type="date" v-model="searchStart" class="date-input"/>
            <span> ~ </span>
            <input type="date" v-model="searchEnd" class="date-input"/>
            <button class="btn search" @click="fetchData">조회</button>
            <button class="btn print" @click="handlePrint">출력</button>
        </div>
        <!-- 차트 2단 그리드 -->
        <div class="chart-cards">
            <div class="chart-card">
                <div class="card-title">진단 유형 분포</div>
                <Doughnut :data="diagnosisTypeData" :options="doughnutOptions"
                          style="width:130px; height:130px; margin:0 auto;" />
            </div>
            <div class="chart-card">
                <div class="card-title">자동/수동 처방 비율</div>
                <Doughnut :data="autoManualData" :options="doughnutOptions"
                          style="width:110px; height:110px; margin:0 auto;" />
            </div>
            <div class="chart-card">
                <div class="card-title">빈도/강도 분포</div>
                <Bar :data="freqIntensityData" :options="barOptions"
                     style="width:150px; height:95px; margin:0 auto;" />
            </div>
            <div class="chart-card">
                <div class="card-title">응답률</div>
                <div class="response-bar-container">
                    <div class="response-bar-bg">
                        <div class="response-bar-actual" :style="{width: responseRate + '%'}"></div>
                    </div>
                    <div class="response-bar-label">{{ responseRate }}%</div>
                </div>
                <button class="btn-small" @click="generateReport">보고서 생성</button>
            </div>
        </div>
    </div>
</template>


<script setup>
import { ref } from 'vue'
import { Doughnut, Bar } from 'vue-chartjs'
import {
    Chart, ArcElement, CategoryScale, LinearScale, BarElement, Tooltip, Legend
} from 'chart.js'
Chart.register(ArcElement, CategoryScale, LinearScale, BarElement, Tooltip, Legend)

// 날짜, 이벤트(기본)
const searchStart = ref('')
const searchEnd = ref('')
const fetchData = () => {/* 실제 데이터 연동 시 구현 */}
const handlePrint = () => { window.print() }
const generateReport = () => { alert('보고서가 생성되었습니다!') }

// 가라데이터 및 차트 옵션
const diagnosisTypeData = {
    labels: ['통증 민감도', '통증 역치', '진동 감각'],
    datasets: [{
        data: [50, 28, 22],
        backgroundColor: ['#1976d2', '#40bfa3', '#fcba37'],
        borderWidth: 1.5
    }]
}
const autoManualData = {
    labels: ['자동', '수동'],
    datasets: [{
        data: [50, 50],
        backgroundColor: ['#40bfa3', '#8c99ae'],
        borderWidth: 1.5
    }]
}
const doughnutOptions = {
    plugins: { legend: { position: 'bottom' } },
    cutout: '65%'
}
const freqIntensityData = {
    labels: ['<10', '10-20', '20-30', '30-40', '40-50', '50-100', '>100'],
    datasets: [{
        label: '빈도',
        backgroundColor: '#1976d2',
        data: [26, 40, 36, 24, 12, 5, 2],
        borderRadius: 8,
        barThickness: 24
    }]
}
const barOptions = {
    indexAxis: 'y',
    plugins: { legend: { display: false } },
    scales: {
        x: { beginAtZero: true }
    },
    responsive: true
}
const responseRate = 78
</script>

